'use strict';

var React = require('react');

var SvgLogOutMinor = function SvgLogOutMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 3a2.25 2.25 0 0 0-2.25 2.25.75.75 0 0 0 1.5 0 .75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v9.5a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1-.75-.75.75.75 0 0 0-1.5 0 2.25 2.25 0 0 0 2.25 2.25h4a2.25 2.25 0 0 0 2.25-2.25v-9.5a2.25 2.25 0 0 0-2.25-2.25h-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 10.75a.75.75 0 0 0 0-1.5h-5.69l.97-.97a.75.75 0 0 0-1.06-1.06l-2.25 2.25a.75.75 0 0 0 0 1.06l2.25 2.25a.75.75 0 0 0 1.06-1.06l-.97-.97h5.69Z"
  }));
};
SvgLogOutMinor.displayName = "LogOutMinor";

exports.SvgLogOutMinor = SvgLogOutMinor;
